// extracted by mini-css-extract-plugin
export default {"header":"o4YMyKr0Ftemo5XKNC6E"};